/**
 * Reviews Masonry
 * Displays Judge.me reviews in a masonry grid (desktop) or simple stack (mobile)
 * Product-only reviews — no backfill from other products.
 */

window.ReviewsMasonry = (function() {
  'use strict';

  var instances = new Map();

  function init(options) {
    var sectionId = options.sectionId;

    if (instances.has(sectionId)) {
      return instances.get(sectionId);
    }

    var section = document.getElementById('ReviewsSection-' + sectionId);
    if (!section) return null;

    var instance = {
      sectionId: sectionId,
      section: section,
      grid: document.getElementById('ReviewsMasonry-' + sectionId),
      loading: document.getElementById('ReviewsLoading-' + sectionId),
      empty: document.getElementById('ReviewsEmpty-' + sectionId),
      filters: document.getElementById('ReviewsFilters-' + sectionId),
      modal: document.getElementById('ReviewsModal-' + sectionId),
      writeBtn: document.getElementById('ReviewsWriteBtn-' + sectionId),
      options: options,
      allReviews: [],
      reviews: [],
      currentFilter: 'all',
      verifiedOnly: false,
      masonry: null,
      isMobile: window.FH && window.FH.ui === 'mobile'
    };

    instances.set(sectionId, instance);
    initFilters(instance);
    initModal(instance);
    loadReviews(instance);

    return instance;
  }

  function initFilters(instance) {
    if (!instance.filters) return;

    var ratingButtons = instance.filters.querySelectorAll('.reviews-masonry__filter[data-rating]');
    ratingButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var rating = btn.dataset.rating;
        instance.currentFilter = rating === 'all' ? 'all' : parseInt(rating, 10);
        ratingButtons.forEach(function(b) { b.classList.remove('reviews-masonry__filter--active'); });
        btn.classList.add('reviews-masonry__filter--active');
        applyFilter(instance);
      });
    });

    var verifiedBtn = instance.filters.querySelector('.reviews-masonry__filter--verified');
    if (verifiedBtn) {
      verifiedBtn.addEventListener('click', function() {
        instance.verifiedOnly = !instance.verifiedOnly;
        verifiedBtn.classList.toggle('reviews-masonry__filter--active', instance.verifiedOnly);
        applyFilter(instance);
      });
    }
  }

  function initModal(instance) {
    var modal = instance.modal;
    var writeBtn = instance.writeBtn;
    if (!modal || !writeBtn) return;

    var backdrop = modal.querySelector('.reviews-masonry__modal-backdrop');
    var closeBtn = modal.querySelector('.reviews-masonry__modal-close');
    var selectedRating = 0;

    function openModal() {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    writeBtn.addEventListener('click', openModal);
    if (backdrop) backdrop.addEventListener('click', closeModal);
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });

    // Star rating picker
    var starsContainer = document.getElementById('ReviewsFormStars-' + instance.sectionId);
    if (starsContainer) {
      var starBtns = starsContainer.querySelectorAll('.reviews-masonry__form-star');
      starBtns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          selectedRating = parseInt(btn.dataset.star, 10);
          starBtns.forEach(function(b) {
            var s = parseInt(b.dataset.star, 10);
            b.textContent = s <= selectedRating ? '★' : '☆';
            b.classList.toggle('reviews-masonry__form-star--active', s <= selectedRating);
          });
        });
        btn.addEventListener('mouseenter', function() {
          var hover = parseInt(btn.dataset.star, 10);
          starBtns.forEach(function(b) {
            var s = parseInt(b.dataset.star, 10);
            b.textContent = s <= hover ? '★' : '☆';
          });
        });
      });
      if (starsContainer) {
        starsContainer.addEventListener('mouseleave', function() {
          starBtns.forEach(function(b) {
            var s = parseInt(b.dataset.star, 10);
            b.textContent = s <= selectedRating ? '★' : '☆';
          });
        });
      }
    }

    // Form submission
    var form = document.getElementById('ReviewsForm-' + instance.sectionId);
    var status = document.getElementById('ReviewsFormStatus-' + instance.sectionId);
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        if (selectedRating === 0) {
          showStatus(status, 'Please select a star rating.', 'error');
          return;
        }

        var nameInput = form.querySelector('[id^="review-name"]');
        var emailInput = form.querySelector('[id^="review-email"]');
        var titleInput = form.querySelector('[id^="review-title"]');
        var bodyInput = form.querySelector('[id^="review-body"]');
        var submitBtn = form.querySelector('.reviews-masonry__form-submit');

        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting...';

        var payload = {
          shop_domain: instance.options.shopDomain,
          platform: 'shopify',
          name: nameInput.value.trim(),
          email: emailInput.value.trim(),
          rating: selectedRating,
          title: titleInput.value.trim(),
          body: bodyInput.value.trim(),
          product_handle: instance.options.productHandle
        };

        fetch('https://judge.me/api/v1/reviews', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            shop_domain: payload.shop_domain,
            platform: payload.platform,
            id: null,
            token: instance.options.apiToken,
            reviewer: { name: payload.name, email: payload.email },
            rating: payload.rating,
            title: payload.title,
            body: payload.body,
            product_handle: payload.product_handle
          })
        })
        .then(function(r) {
          if (r.ok || r.status === 201) return r.json();
          throw new Error('Submission failed');
        })
        .then(function() {
          showStatus(status, 'Thank you! Your review has been submitted and will appear once approved.', 'success');
          form.reset();
          selectedRating = 0;
          if (starsContainer) {
            starsContainer.querySelectorAll('.reviews-masonry__form-star').forEach(function(b) {
              b.textContent = '☆';
              b.classList.remove('reviews-masonry__form-star--active');
            });
          }
          submitBtn.disabled = false;
          submitBtn.textContent = 'Submit Review';
        })
        .catch(function(err) {
          console.error('[ReviewsMasonry] Submit error:', err);
          showStatus(status, 'Something went wrong. Please try again.', 'error');
          submitBtn.disabled = false;
          submitBtn.textContent = 'Submit Review';
        });
      });
    }
  }

  function showStatus(el, msg, type) {
    if (!el) return;
    el.hidden = false;
    el.textContent = msg;
    el.className = 'reviews-masonry__form-status reviews-masonry__form-status--' + type;
  }

  function applyFilter(instance) {
    if (!instance.allReviews || instance.allReviews.length === 0) {
      showEmpty(instance);
      return;
    }

    instance.reviews = instance.allReviews.filter(function(r) {
      var matchesRating = instance.currentFilter === 'all' || r.rating === instance.currentFilter;
      var matchesVerified = !instance.verifiedOnly || r.verified;
      return matchesRating && matchesVerified;
    });

    if (instance.reviews.length === 0) {
      // Clear grid — reset masonry state
      instance.masonry = null;
      if (instance.grid) {
        delete instance.grid.dataset.masonryInitialized;
        delete instance.grid._masonryInstance;
        instance.grid.className = 'masonry-grid reviews-masonry__grid';
        instance.grid.removeAttribute('style');
        instance.grid.innerHTML = '';
      }
      if (instance.empty) {
        instance.empty.hidden = false;
        var msg = 'No ';
        if (instance.currentFilter !== 'all') msg += instance.currentFilter + '-star ';
        if (instance.verifiedOnly) msg += 'verified ';
        msg += 'reviews yet.';
        instance.empty.querySelector('p').textContent = msg;
      }
      if (instance.loading) instance.loading.hidden = true;
      document.body.classList.add('masonry-ready');
    } else {
      if (instance.empty) instance.empty.hidden = true;
      renderReviews(instance);
    }
  }

  /**
   * Load reviews from Judge.me — product-only, no backfill
   */
  function loadReviews(instance) {
    var opts = instance.options;
    var shopDomain = opts.shopDomain;
    var apiToken = opts.apiToken;
    var productHandle = opts.productHandle;
    var maxReviews = opts.maxReviews || 24;

    if (!shopDomain || !apiToken) {
      showEmpty(instance);
      return;
    }

    if (instance.loading) instance.loading.hidden = false;
    if (instance.grid) instance.grid.style.display = 'none';
    if (instance.empty) instance.empty.hidden = true;

    // Product-specific reviews only
    var apiUrl;
    if (productHandle) {
      apiUrl = 'https://judge.me/api/v1/widgets/product_review?' +
        'api_token=' + encodeURIComponent(apiToken) +
        '&shop_domain=' + encodeURIComponent(shopDomain) +
        '&handle=' + encodeURIComponent(productHandle) +
        '&per_page=' + maxReviews;
    } else {
      // Non-product page — show all store reviews
      apiUrl = 'https://judge.me/api/v1/widgets/all_reviews_page?' +
        'api_token=' + encodeURIComponent(apiToken) +
        '&shop_domain=' + encodeURIComponent(shopDomain) +
        '&per_page=' + maxReviews;
    }

    fetch(apiUrl)
      .then(function(response) {
        if (!response.ok) throw new Error('API request failed');
        return response.json();
      })
      .then(function(data) {
        var widgetHtml = data.widget || data.all_reviews || '';
        var reviews = parseWidgetHtml(widgetHtml, maxReviews);
        instance.allReviews = reviews;
        applyFilter(instance);
      })
      .catch(function(err) {
        console.error('[ReviewsMasonry] API error:', err);
        showEmpty(instance);
      });
  }

  function parseWidgetHtml(html, maxReviews) {
    var reviews = [];
    if (!html) return reviews;

    html = html.replace(/\\u003c/g, '<').replace(/\\u003e/g, '>').replace(/\\u0026/g, '&');
    var blocks = html.split(/<div class=['"]jdgm-rev jdgm-divider-top['"]/).slice(1);

    blocks.slice(0, maxReviews).forEach(function(block) {
      var review = {};

      var idMatch = block.match(/data-review-id=['"]([^'"]+)['"]/);
      review.id = idMatch ? idMatch[1] : null;

      var verifiedMatch = block.match(/data-verified-buyer=['"]([^'"]+)['"]/);
      review.verified = verifiedMatch ? verifiedMatch[1] === 'true' : false;

      var ratingMatch = block.match(/data-score=['"](\d+)['"]/);
      review.rating = ratingMatch ? parseInt(ratingMatch[1], 10) : 5;

      var authorMatch = block.match(/jdgm-rev__author[^>]*>([^<]+)</) ||
        block.match(/data-author=['"]([^'"]+)['"]/);
      review.author = authorMatch ? decodeHtmlEntities(authorMatch[1].trim()) : '';

      var titleMatch = block.match(/<b class=['"]jdgm-rev__title['"]>([^<]*)<\/b>/);
      review.title = titleMatch ? decodeHtmlEntities(titleMatch[1].trim()) : '';

      var bodyMatch = block.match(/<div class=['"]jdgm-rev__body['"]>(?:<p>)?([^<]+)/);
      review.body = bodyMatch ? decodeHtmlEntities(bodyMatch[1].trim()) : '';

      var dateMatch = block.match(/data-content=['"]([^'"]+)['"]/);
      review.date = dateMatch ? formatDate(dateMatch[1]) : '';

      review.photos = [];
      var photoMatches = block.match(/jdgm-rev__pic[^>]*data-full-src=['"]([^'"]+)['"]/g);
      if (photoMatches) {
        photoMatches.forEach(function(match) {
          var urlMatch = match.match(/data-full-src=['"]([^'"]+)['"]/);
          if (urlMatch) review.photos.push(urlMatch[1]);
        });
      }

      if (review.body || review.title) {
        reviews.push(review);
      }
    });

    return reviews;
  }

  function decodeHtmlEntities(text) {
    var textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    return textarea.value;
  }

  function formatDate(dateStr) {
    if (!dateStr) return '';
    try {
      var date = new Date(dateStr);
      var now = new Date();
      var diffDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));

      if (diffDays === 0) return 'Today';
      if (diffDays === 1) return 'Yesterday';
      if (diffDays < 7) return diffDays + ' days ago';
      if (diffDays < 14) return '1 week ago';
      if (diffDays < 30) return Math.floor(diffDays / 7) + ' weeks ago';
      if (diffDays < 60) return '1 month ago';
      if (diffDays < 183) return Math.floor(diffDays / 30) + ' months ago';
      return 'Over 6 months ago';
    } catch (e) {
      return '';
    }
  }

  function renderReviews(instance) {
    var grid = instance.grid;
    if (!grid) return;

    // Reset masonry state so PinterestMasonry constructor doesn't return stale instance
    instance.masonry = null;
    delete grid.dataset.masonryInitialized;
    delete grid._masonryInstance;

    // Reset to clean state
    grid.className = 'masonry-grid reviews-masonry__grid';
    grid.removeAttribute('style');
    grid.innerHTML = '';

    // Summary card first
    if (instance.allReviews.length > 0) {
      var summaryCard = createSummaryCard(instance);
      grid.appendChild(summaryCard);
    }

    instance.reviews.forEach(function(review) {
      var card = createReviewCard(review);
      grid.appendChild(card);
    });

    if (instance.loading) instance.loading.hidden = true;

    if (instance.isMobile) {
      initMobileLayout(instance);
    } else {
      // Defer masonry init to next frame so DOM is fully laid out
      requestAnimationFrame(function() {
        initDesktopMasonry(instance);
      });
    }
  }

  function createReviewCard(review) {
    var card = document.createElement('div');
    card.className = 'reviews-masonry__card masonry-item';
    card.dataset.itemType = 'review';
    card.dataset.dynamicHeight = 'true';

    var html = '<div class="reviews-masonry__card-inner">';

    html += '<div class="reviews-masonry__card-header">';
    html += '<div class="reviews-masonry__stars">' + renderStars(review.rating) + '</div>';
    if (review.verified) {
      html += '<span class="reviews-masonry__verified">✓ Verified</span>';
    }
    html += '</div>';

    if (review.title) {
      html += '<h3 class="reviews-masonry__card-title">' + escapeHtml(review.title) + '</h3>';
    }

    if (review.body) {
      var t = truncateWords(review.body, 50);
      html += '<p class="reviews-masonry__card-body">' + escapeHtml(t.text);
      if (t.truncated) {
        html += '<span class="reviews-masonry__read-more">… read more</span>';
      }
      html += '</p>';
    }

    if (review.photos && review.photos.length > 0) {
      html += '<div class="reviews-masonry__photos">';
      review.photos.slice(0, 3).forEach(function(photo) {
        html += '<img src="' + photo + '" alt="Review photo" class="reviews-masonry__photo" loading="lazy">';
      });
      html += '</div>';
    }

    if (review.author || review.date) {
      html += '<div class="reviews-masonry__card-footer">';
      if (review.author) {
        html += '<span class="reviews-masonry__author">' + escapeHtml(review.author) + '</span>';
      }
      if (review.date) {
        html += '<span class="reviews-masonry__date">' + escapeHtml(review.date) + '</span>';
      }
      html += '</div>';
    }

    html += '</div>';
    card.innerHTML = html;
    return card;
  }

  function createSummaryCard(instance) {
    var card = document.createElement('div');
    card.className = 'reviews-masonry__card reviews-masonry__card--summary masonry-item';
    card.dataset.itemType = 'summary';
    card.dataset.dynamicHeight = 'true';

    var all = instance.allReviews;
    var total = all.length;
    var counts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    var sum = 0;
    all.forEach(function(r) {
      if (counts[r.rating] !== undefined) counts[r.rating]++;
      sum += r.rating;
    });

    // Use metafield rating if available, otherwise calculate
    var avg = instance.options.metaRating || (total > 0 ? (sum / total).toFixed(1) : '0');
    var count = instance.options.metaCount || total;

    var html = '<div class="reviews-masonry__card-inner reviews-masonry__summary-inner">';
    html += '<div class="reviews-masonry__summary-score">';
    html += '<span class="reviews-masonry__summary-number">' + avg + '</span>';
    html += '<span class="reviews-masonry__summary-outof">out of 5</span>';
    html += '</div>';
    html += '<div class="reviews-masonry__summary-stars">' + renderStars(Math.round(parseFloat(avg))) + '</div>';
    html += '<span class="reviews-masonry__summary-count">' + count + ' ' + (count == 1 ? 'rating' : 'ratings') + '</span>';

    // Histogram
    html += '<div class="reviews-masonry__histogram">';
    for (var star = 5; star >= 1; star--) {
      var pct = total > 0 ? Math.round((counts[star] / total) * 100) : 0;
      html += '<div class="reviews-masonry__histogram-row" data-star="' + star + '">';
      html += '<span class="reviews-masonry__histogram-label">' + star + ' star</span>';
      html += '<div class="reviews-masonry__histogram-bar">';
      html += '<div class="reviews-masonry__histogram-fill" style="width:' + pct + '%"></div>';
      html += '</div>';
      html += '<span class="reviews-masonry__histogram-pct">' + pct + '%</span>';
      html += '</div>';
    }
    html += '</div>';
    html += '</div>';

    card.innerHTML = html;

    // Make histogram rows clickable as filters
    var rows = card.querySelectorAll('.reviews-masonry__histogram-row');
    rows.forEach(function(row) {
      row.style.cursor = 'pointer';
      row.addEventListener('click', function() {
        var star = parseInt(row.dataset.star, 10);
        instance.currentFilter = instance.currentFilter === star ? 'all' : star;
        // Update filter buttons
        var btns = instance.filters.querySelectorAll('.reviews-masonry__filter[data-rating]');
        btns.forEach(function(b) {
          b.classList.toggle('reviews-masonry__filter--active',
            b.dataset.rating === String(instance.currentFilter) ||
            (instance.currentFilter === 'all' && b.dataset.rating === 'all'));
        });
        applyFilter(instance);
      });
    });

    return card;
  }

  function truncateWords(text, max) {
    var words = text.split(/\s+/);
    if (words.length <= max) return { text: text, truncated: false };
    return { text: words.slice(0, max).join(' '), truncated: true };
  }

  function renderStars(rating) {
    var html = '';
    for (var i = 1; i <= 5; i++) {
      if (i <= rating) {
        html += '<span class="reviews-masonry__star reviews-masonry__star--filled">★</span>';
      } else {
        html += '<span class="reviews-masonry__star reviews-masonry__star--empty">☆</span>';
      }
    }
    return html;
  }

  function initMobileLayout(instance) {
    var grid = instance.grid;
    if (!grid) return;
    grid.classList.add('reviews-masonry__grid--mobile');
    grid.classList.add('masonry-grid--initialized');
    document.body.classList.add('masonry-ready');
  }

  function initDesktopMasonry(instance) {
    var grid = instance.grid;
    if (!grid) return;

    if (window.MasonryFeed && window.MasonryFeed.PinterestMasonry) {
      grid.classList.add('reviews-masonry__grid--desktop');
      try {
        instance.masonry = new window.MasonryFeed.PinterestMasonry(grid, {
          gap: 16,
          itemSelector: '.masonry-item'
        });
      } catch (e) {
        // Masonry failed — fall back to CSS grid
        grid.classList.remove('reviews-masonry__grid--desktop');
        grid.classList.add('reviews-masonry__grid--mobile');
        grid.classList.add('masonry-grid--initialized');
      }
    } else {
      // MasonryFeed not loaded — use CSS grid fallback
      grid.classList.add('reviews-masonry__grid--mobile');
      grid.classList.add('masonry-grid--initialized');
    }
    document.body.classList.add('masonry-ready');
  }

  function showEmpty(instance) {
    if (instance.loading) instance.loading.hidden = true;
    if (instance.empty) instance.empty.hidden = false;
    instance.masonry = null;
    if (instance.grid) {
      delete instance.grid.dataset.masonryInitialized;
      delete instance.grid._masonryInstance;
      instance.grid.className = 'masonry-grid reviews-masonry__grid';
      instance.grid.removeAttribute('style');
      instance.grid.innerHTML = '';
    }
    document.body.classList.add('masonry-ready');
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function destroy(sectionId) {
    var instance = instances.get(sectionId);
    if (!instance) return;
    if (instance.grid) instance.grid.innerHTML = '';
    instances.delete(sectionId);
  }

  return {
    init: init,
    destroy: destroy,
    instances: instances
  };
})();
